import {
  Card,
  CardBody,
  Image,
  Link as MuiLink,
  Text,
  VStack,
} from "@chakra-ui/react";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import images from "../../assets/img";
import SignUpForm, {
  SignUpFormValues,
} from "../../components/forms/SignUpForm";
import useSignUp from "../../hooks/api/auth/useSignUp";
import BasePage from "./BasePage";

export default function SingUpPage() {
  const { t } = useTranslation();
  const {
    mutateAsync: signUp,
    isPending: isSignUpLoading,
    isSuccess: isSignUpSuccess,
  } = useSignUp();

  const onSubmit = useCallback(
    ({ languages, ...rest }: SignUpFormValues) => {
      signUp({
        signUpData: {
          ...rest,
          languageIds: languages.map(({ id }) => id),
        },
      });
    },
    [signUp],
  );

  return (
    <BasePage
      hasBoxWrapper={false}
      withBreadcrumb={false}
      containerProps={{
        justifyContent: "center",
        alignItems: "center",
        display: "flex",
        mt: 8,
      }}
    >
      <Card maxW="md" mb={12} flexGrow={1}>
        <CardBody display="flex" justifyContent="center" flexDirection="column">
          <Image
            src={images.logoSapienza}
            alignSelf="center"
            height={20}
            alt="Logo sapienza"
          />
          {isSignUpSuccess ? (
            <VStack>
              <Text my={4} textAlign="center" whiteSpace="pre-line">
                {t("sign_up_page.email_sent")}
              </Text>
              <MuiLink as={Link} to="/" color={"primary.DEFAULT"}>
                {t("common.buttons.go_back")}
              </MuiLink>
            </VStack>
          ) : (
            <SignUpForm onSubmit={onSubmit} isLoading={isSignUpLoading} />
          )}
        </CardBody>
      </Card>
    </BasePage>
  );
}
